<script setup>
import { defineProps } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import TableRow from './TableRow'

defineProps({
  groups: Array
})
const store = useStore()
const router = useRouter()

// enter customer
const enterCustomer = (group) => {
  if (group['count'] === 0)
    return store.dispatch('addToast', {
      type: 'error',
      message: 'در این سطح مشتری وجود ندارد.'
    })
  router.push({
    name: 'Customer',
    query: { group: group['id'], type: 4, groupName: group['name'] }
  })
}
</script>

<template>
  <div class="main-wrapper">
    <div class="shop-table">
      <div class="table-header">
        <h2>نام سطح</h2>
        <h2>حداقل خرید</h2>
        <h2>مشتریان</h2>
      </div>
      <template v-for="group in groups" :key="group.id">
        <a @click="enterCustomer(group)">
          <table-row
            :title="group['name']"
            :counter="!group['is_default'] ? group['min_buy'] : 0"
            :customers="group['count']"
          />
          <p class="table-row-desc" v-if="!group['is_default']">
            {{ group['desc'] ? group['desc'] : 'توضیحاتی داده نشده است.' }}
          </p>
        </a>
        <i class="sep" />
      </template>
    </div>
    <div class="credit-buttons">
      <router-link
        :to="{ name: 'CustomerSort' }"
        class="button button--visible"
      >
        <span class="button__text">تنظیمات</span>
        <svg class="button__icon" viewBox="0 0 24 24">
          <path
            d="m13.12 24h-2.24c-.757 0-1.396-.567-1.486-1.32l-.239-1.876c-.477-.155-.937-.346-1.374-.569l-1.494 1.161c-.606.469-1.459.415-1.985-.126l-1.575-1.575c-.537-.521-.591-1.374-.122-1.979l1.161-1.495c-.224-.437-.415-.897-.569-1.374l-1.88-.239c-.75-.092-1.317-.731-1.317-1.488v-2.24c0-.757.567-1.396 1.32-1.486l1.876-.239c.155-.477.346-.937.569-1.374l-1.16-1.494c-.47-.606-.415-1.46.127-1.986l1.575-1.575c.521-.537 1.375-.59 1.979-.122l1.494 1.162c.437-.223.897-.414 1.375-.569l.239-1.88c.09-.75.729-1.317 1.486-1.317h2.24c.757 0 1.396.567 1.486 1.32l.239 1.876c.478.155.938.346 1.375.569l1.494-1.161c.607-.469 1.459-.415 1.985.127l1.575 1.575c.537.521.591 1.374.122 1.979l-1.161 1.495c.224.437.415.897.569 1.374l1.88.239c.749.091 1.316.73 1.316 1.487v2.24c0 .757-.567 1.396-1.32 1.486l-1.876.239c-.155.477-.346.937-.569 1.374l1.161 1.494c.47.606.415 1.459-.127 1.985l-1.575 1.575c-.521.537-1.375.592-1.979.122l-1.495-1.161c-.437.224-.897.415-1.374.569l-.239 1.88c-.091.75-.73 1.317-1.487 1.317zm-5.39-4.86c.083 0 .168.021.244.063.551.308 1.148.556 1.774.736.192.055.333.219.358.417l.28 2.2c.03.251.247.444.494.444h2.24c.247 0 .464-.193.493-.439l.281-2.204c.025-.198.166-.362.358-.417.626-.18 1.223-.428 1.774-.736.175-.098.393-.081.55.042l1.75 1.36c.201.156.483.143.655-.034l1.585-1.585c.181-.176.195-.458.039-.66l-1.36-1.75c-.123-.158-.14-.375-.042-.55.308-.551.556-1.148.736-1.774.055-.192.219-.333.417-.358l2.2-.28c.251-.031.444-.248.444-.495v-2.24c0-.247-.193-.464-.439-.493l-2.204-.281c-.198-.025-.362-.166-.417-.358-.18-.626-.428-1.223-.736-1.774-.098-.175-.082-.392.042-.55l1.36-1.75c.157-.202.143-.484-.033-.654l-1.585-1.585c-.175-.182-.458-.196-.66-.039l-1.75 1.36c-.159.123-.376.14-.551.042-.549-.308-1.146-.555-1.774-.736-.192-.055-.333-.219-.358-.417l-.28-2.2c-.031-.252-.248-.445-.495-.445h-2.24c-.247 0-.464.193-.493.439l-.281 2.204c-.025.198-.166.362-.358.418-.628.18-1.225.428-1.774.735-.175.099-.392.081-.551-.041l-1.75-1.36c-.202-.157-.483-.143-.654.033l-1.585 1.586c-.181.176-.195.458-.039.66l1.36 1.75c.123.158.14.375.042.55-.309.551-.556 1.148-.736 1.774-.055.192-.219.333-.417.358l-2.2.28c-.251.03-.444.247-.444.494v2.24c0 .247.193.464.439.493l2.204.281c.198.025.362.166.417.358.18.626.428 1.223.736 1.774.098.175.082.392-.042.55l-1.36 1.75c-.157.202-.143.484.033.654l1.585 1.585c.175.181.456.195.66.039l1.75-1.36c.091-.068.199-.104.308-.104z"
          />
          <path
            d="m12 17c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5zm0-9c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4z"
          />
        </svg>
      </router-link>
    </div>
  </div>
</template>

<style scoped lang="scss">
.main-wrapper {
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: 40px;
}
.shop-table {
  width: 96%;
  border-radius: 30px;
  overflow: hidden;
  padding: 0;
  display: flex;
  flex-direction: column;
  z-index: 1;
  position: relative;
  background: linear-gradient(to right, #c9b58f 0, #c9c8c6 100%);
  .table-header {
    border-radius: 30px 30px 0 0;
    width: 100%;
    position: relative;
    top: -1px;
    display: grid;
    align-items: center;
    grid-template-columns: 30px 4fr 6fr 25% 10px;
    color: #fff;
    background-color: #000;
    height: 60px;

    h2 {
      text-align: center;
      font-size: 14px;
      margin: 0;
      &:nth-child(1) {
        grid-column: 1/3;
        text-align: right;
        margin-right: 20px;
      }
      &:nth-child(2) {
        grid-column: 3/4;
        justify-self: start;
        text-align: right;
      }
      &:nth-child(3) {
        grid-column: 4/5;
        margin-right: -5px;
        text-align: center;
      }
    }
  }
}
.sep {
  background-color: rgba(255, 255, 255, 0.2);
  width: 96%;
  margin: 0 auto;
  height: 1px;
  &:last-child {
    display: none;
  }
}

.table-row-desc {
  width: 100%;
  text-align: right;
  background-color: #333;
  padding: 15px 10px 15px 5px;
  cursor: pointer;
  font-size: 12px;
  color: #bbb;
}
// change in common css
.credit-buttons {
  flex-direction: column;
  margin: 15px 0 0;
  .button--visible {
    width: 75%;
    border-radius: 20px;
    .button__icon {
      transform: rotate(30deg);
      width: 25px;
      height: 25px;
      fill: #777;
      margin-right: 8px;
    }
  }
}
</style>
